<template>
  <div class="main scroll" ref="scroll">
    <div class="scroll-wrapper">
      <div class="head-title">
        <div class="left">
          <div @click="$router.back()" class="name">学生相册</div>
          <div class="icon">></div>
          <div class="main blue">
            {{ studentName }}
          </div>
          <a-select
            style="width:160px;margin-left:10px"
            v-model="id"
            size="small"
            @change="changeType"
          >
            <a-select-option
              v-for="item in albumList"
              :key="item.id"
              :value="item.id"
              >{{ item.name }}</a-select-option
            >
          </a-select>
          <!-- <a-icon style="{color:#f1f8fd}" type="caret-down" /> -->
        </div>
        <div class="right">
          <div class="num">
            照片数量<span class="blue">{{ photoList.length }}</span>
          </div>
          <div class="msg">
            <div class="txt blue">相册信息</div>
            <a-icon style="{color:#898989}" type="caret-down" />
          </div>
        </div>
      </div>
      <div class="content">
        <div class="frame-list">
          <div
            @click="selectPhoto($event, index)"
            @dblclick="showBigPic(item.img_url)"
            v-for="(item, index) in photoList"
            :key="index"
            class="cell"
            :class="item.select ? 'select' : ''"
            :style="{ backgroundImage: 'url(' + item.img_url + ')' }"
          >
            <!-- <img class="photo" :src="item && item.img_url" alt="" /> -->
            <!-- <div v-if="item.is_sb && !item.binding" class="tip">已识</div>
            <div v-if="item.binding" class="bind">分配</div> -->
          </div>
        </div>
      </div>
      <a-modal :visible="previewVisible" width="800px" :footer="null" @cancel="handleCancel">
        <div style="padding:20px">
          <img alt="example" style="width: 100%" :src="previewImage" />
        </div>
      </a-modal>
      <div class="pagebox">
        <a-pagination
          show-quick-jumper
          :defaultPageSize="23"
          :current="currentPage"
          :total="total"
          @change="onChangePage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
// import BetterScroll from "better-scroll";
import _ from "lodash";
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}
export default {
  data() {
    return {
      photoList: [],
      currentPhoto: null,
      currentIndex: -1,
      rightContentLeft: 0,
      rightContentTop: 0,
      photoName: "",
      backimg1: require("../assets/doc.png"),
      backimg2: require("../assets/doc-01.png"),
      id: "",
      studentId: "",
      studentName: "",
      type: "全部照片",
      rightStyle: {
        left: 0,
        top: 0,
      },
      albumList: [],
      studentList: [],
      currentPage: 1,
      total: 0,
      previewVisible:false,
      previewImage: "",
    };
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.scroll = new BetterScroll(this.$refs.scroll, {
    //     scrollY: true,
    //     scrollbar: true,
    //     mouseWheel: {
    //       speed: 20,
    //       invert: false,
    //       easeTime: 300,
    //     },
    //   });
    // });
  },
  computed: {
    ...mapState(["headers", "userInfo"]),
  },
  created() {
    this.studentName = this.$route.query.name;
    this.studentId = this.$route.params.studentId;
    if (this.userInfo) {
      this.getAlbum();
      this.getStudent();
    }
  },
  filters: {
    filterIndex(index) {
      if (index < 9) {
        return "0" + (index + 1);
      } else {
        return index + 1;
      }
    },
  },
  watch: {
    userInfo(val) {
      if (val) {
        this.getAlbum();
        this.getStudent();
      }
    },
  },
  methods: {
    handleCancel() {
      this.previewVisible = false;
    },
    selectPhoto($event, index) {
      if ($event.shiftKey) {
        this.photoList = this.photoList.map((arr, arrIndex) => {
          arr.select = false;
          if (this.currentIndex >= index) {
            if (arrIndex >= index && arrIndex <= this.currentIndex) {
              arr.select = true;
            }
          } else {
            if (arrIndex <= index && arrIndex >= this.currentIndex) {
              arr.select = true;
            }
          }
          return arr;
        });
        this.currentIndex = index;
        return false;
      }
      if ($event.ctrlKey) {
        this.photoList[index].select = !this.photoList[index].select;
        this.$forceUpdate();
        this.currentIndex = index;
        return false;
      }
      if (!$event.shiftKey && !$event.ctrlKey) {
        this.photoList = this.photoList.map((arr, index2) => {
          arr.select = false;
          if (index2 == index) {
            arr.select = true;
          }
          return arr;
        });
        this.currentIndex = index;
      }
    },
    clearUrl(url) {
      console.log(url)
      if(!url) {
        url = ''
      } else if (url.indexOf('?')) {
        url = url.split('?')[0]
      } 
      return url
    },
    showBigPic(url) {
      console.log(url)
      this.previewImage = this.clearUrl(url)
      this.previewVisible = true
    },
    onChangePage(e) {
      this.currentPage = e;
      this.photoList = [];
      this.getPhoto();
    },
    handleRemoveStudent() {
      this.studentList = this.studentList.map((arr) => {
        arr.select = false;
        return arr;
      });
    },
    getStudent() {
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.studentList,
        headers: { Authorization: this.$store.state.headers },
      })
        .then((res) => {
          this.studentList = res.data.data.rows;
        })
        .catch((res) => {
          this.$message.error(res.data.msg);
        });
    },
    getAlbum() {
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.albumList,
        headers: { Authorization: this.$store.state.headers },
        data: {
          complete_id:this.$route.params.c_id,
          class_id: this.userInfo.class_id,
          limit: 200,
        },
      })
        .then((res) => {
          if (res.data.status == 200) {
            this.albumList = res.data.data.data;
            this.id = this.albumList[0].id
            this.getPhoto();
          }
        })
        .catch((res) => {
          console.log(res);
          this.$message.error("服务器或网络错误");
        });
    },
    cancelDisModel() {
      this.photoList = this.photoList.map((arr) => {
        arr.select = false;
        return arr;
      });
      this.disModal = false;
    },
    handleAllDis() {
      this.studentList = this.studentList.map((arr) => {
        arr.select = true;
        return arr;
      });
    },
    selectStudent(index) {
      this.studentList[index].select = !this.studentList[index].select;
      this.$forceUpdate();
    },
    showDisModel() {
      if (this.currentIndex > -1) {
        this.$axios({
          method: "POST",
          url: this.$api.domain + this.$api.img_info,
          headers: { Authorization: this.$store.state.headers },
          data: { album_id: this.photoList[this.currentIndex].id },
        })
          .then((res) => {
            if (res.data.status == 200) {
              if (res.data.data.binding && res.data.data.binding !== {}) {
                for (const id in res.data.data.binding) {
                  this.studentList.forEach((arr) => {
                    if (arr.id == id) {
                      arr.select = true;
                    }
                    return arr;
                  });
                }
              }
              this.disModal = true;
            }
          })
          .catch(() => {
            this.$message.error("网络或服务器未知错误");
          });
      }
    },
    changeType() {
      this.getPhoto();
    },
    handleUpload() {
      if (this.uploadState) return false;
      var img_url = [];
      var errors = []
      var state = true;
      for (let i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i].status == 'done' && this.fileList[i].response && this.fileList[i].response.data) {
            img_url.push(this.fileList[i].response.data.url);
        } else if (this.fileList[i].status == 'uploading') {
          state = false;
          break;
        } else if (this.fileList[i].status == 'error' || this.fileList[i].response != 200) {
          errors.push(i+1)
        } 
      }
      if (!state) return false;
      if (errors.length > 0) {
        this.$message.error(`第${errors.join(',')}文件上传失败`)
      }
      if (img_url.length == 0) {
        this.uploadState = false;
        this.fileList = [];
        this.uploadModal = false;
        return false
      }
      this.uploadState = true;
      this.$message.loading({
        content: "Loading...",
        key: "uploadState",
        duration: 10,
      });
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.addStudentPhoto,
        headers: { Authorization: this.$store.state.headers },
        data: {
          album_id: this.id,
          img_url: img_url.join(","),
          student_id: this.studentId,
        },
      })
        .then((res) => {
          this.uploadState = false;
          this.fileList = [];
          setTimeout(() => {
            this.$message.info({
              content: res.data.msg,
              key: "uploadState",
              duration: 2,
            });
          }, 1000);
          if (res.data.status == 200) {
            this.uploadModal = false;
            this.getPhoto();
          }
        })
        .catch(() => {
          this.uploadState = false;
          this.$message.error("网络或服务器未知错误");
        });
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    getPhoto() {
      this.$message.loading({
        key:'load',
        content:'加载中...'
      })
      this.$axios({
        method: "GET",
        url: this.$api.domain + this.$api.studentAlbumPhoto,
        headers: { Authorization: this.$store.state.headers },
        params: {
          album_id: this.id,
          student_id: Number(this.studentId),
          limit: 23,
          page: this.currentPage,
        },
      })
        .then((res) => {
          this.$message.success({content:'获取成功',key:'load',duration:1});
          if (res.data.status == 200 && res.data.data.data.length > 0) {
            this.total = res.data.data.total;
            this.photoList = res.data.data.data.map((arr) => {
              arr.select = false;
              return arr;
            });
          } else {
            this.photoList = [];
            this.$message.error('暂无数据')
          }
          // this.$nextTick(() => {
          //   this.scroll = new BetterScroll(this.$refs.scroll, {
          //     scrollY: true,
          //     scrollbar: true,
          //     mouseWheel: {
          //       speed: 20,
          //       invert: false,
          //       easeTime: 300,
          //     },
          //   });
          // });
        })
        .catch((res) => {
          console.log(res);
          this.$message.error("服务器或网络错误");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.student-list {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-top: 20px;
  flex-wrap: wrap;
  .cell {
    cursor: pointer;
    margin-bottom: 30px;
  }
  .tx {
    width: 60px;
    height: 60px;
    border-radius: 60px;
    margin-right: 30px;
  }
  .name {
    width: 60px;
    text-align: center;
    color: #888;
    margin-top: 10px;
    font-size: 14px;
  }
}
.scroll {
  position: absolute;
  left: -20px;
  right: -20px;
  padding-left: 20px;
  top: 0;
  bottom: 0;
  overflow: hidden;
  box-sizing: border-box;
  .scroll-wrapper {
    height: 100%;
    overflow-y: scroll;
    padding-right: 20px;
    box-sizing: border-box;
  }
}
.head-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  .left {
    flex: 1 1 0%;
    display: flex;
    flex-direction: row;
    align-items: center;
    .main {
      font-size: 16px;
    }
  }
  .right {
    flex: 1 1 0%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    .msg {
      display: flex;
      flex-direction: row;
      align-items: center;
      .txt {
        margin-right: 3px;
      }
    }
  }
}
.frame-list {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  margin-top: 30px;
  .addframe {
    width: 175px;
    margin-bottom: 30px;
    margin-right: 30px;
    cursor: pointer;
  }
  .addbox {
    width: 250px;
    height: 130px;
    border-radius: 0 20px 0 20px;

    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 3px dashed #67b0dc;
    cursor: pointer;
    .add {
      font-size: 40px;
    }
    .addtip {
      font-size: 20px;
      color: #67b0dc;
      margin-bottom: 16px;
    }
  }

  .cell {
    width: 175px;
    height: 143px;
    display: flex;
    flex-direction: row;
    margin-bottom: 30px;
    box-sizing: border-box;
    margin-right: 30px;
    position: relative;
    background-size: contain;
    background-position: center;
    background-color: #eee;
    background-repeat: no-repeat;
    .photo {
      width: 100%;
      height: 100%;
    }
    .tip {
      position: absolute;
      left: 0;
      top: 0;
      padding: 2px 10px;
      box-sizing: border-box;
      color: #fff;
      background: #67b0dc;
      border-radius: 0 0 6px 0px;
      box-shadow: 2px 2px 2px 2px rgba($color: #000000, $alpha: 0.02);
    }
    .bind {
      position: absolute;
      left: 0;
      top: 0;
      padding: 2px 10px;
      box-sizing: border-box;
      color: #fff;
      background: #df815c;
      border-radius: 0 0 6px 0px;
      box-shadow: 2px 2px 2px 2px rgba($color: #000000, $alpha: 0.02);
    }
    &.select {
      border: 3px solid #67b0dc;
      &::after {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: rgba($color: #000000, $alpha: 0.3);
      }
    }
    .msg {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .top {
        cursor: pointer;
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        color: #fff;
        font-size: 18px;
        img {
          width: 20px;
          margin-left: 10px;
        }
      }
      .foot {
        font-size: 14px;
        color: #fff;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-end;
        .order {
          font-size: 30px;
          line-height: 1;
        }
      }
    }
  }
}
.frame-list div,
.frame-list span {
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  -ms-user-select: none;
}
::-webkit-scrollbar-track-piece {
  background-color: #f1f1f1;
}
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-thumb {
  background-color: #a8b3bb;
  background-clip: padding-box;
  min-height: 28px;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb:hover {
  background-color: #bbb;
}
.head-title .left .name {
  font-size: 12px;
}
.head-title .left .icon {
  margin: 0 6px;
}
::v-deep .ant-select-selection-selected-value {
  font-size: 12px;
}
::v-deep .ant-upload.ant-upload-drag {
  margin-bottom: 8px;
}
::v-deep .ant-upload-list {
  overflow: hidden;
}
.pagebox {
  text-align: center;
}
.allRemove {
  background: #e76969;
  margin-left: 10px;
  color: #fff;
  font-size: 12px;
  border-radius: 100px;
  padding: 4px 10px;
  cursor: pointer;
}
.dis-list {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  .dis-cell {
    width: 175px;
    height: 143px;
    margin-bottom: 10px;
    box-sizing: border-box;
    margin-right: 10px;
    position: relative;
    .dis-photo {
      width: 100%;
      height: 100%;
    }
    .tip {
      position: absolute;
      left: 0;
      top: 0;
      padding: 2px 10px;
      box-sizing: border-box;
      color: #fff;
      background: #67b0dc;
      border-radius: 0 0 6px 0px;
      box-shadow: 2px 2px 2px 2px rgba($color: #000000, $alpha: 0.02);
    }
    .bind {
      position: absolute;
      left: 0;
      top: 0;
      padding: 2px 10px;
      box-sizing: border-box;
      color: #fff;
      background: #df815c;
      border-radius: 0 0 6px 0px;
      box-shadow: 2px 2px 2px 2px rgba($color: #000000, $alpha: 0.02);
    }
    &.select {
      border: 3px solid #67b0dc;
      &::after {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: rgba($color: #000000, $alpha: 0.3);
      }
    }
  }
}
.section {
  width: 100%;
  margin-top: 5px;
  .head {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    .name {
      color: #67b0dc;
      margin-right: 6px;
    }
    .alldis {
      background: #67b0dc;
      color: #fff;
      font-size: 12px;
      border-radius: 100px;
      padding: 4px 10px;
      cursor: pointer;
    }
  }
  .student-list {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    .student-cell {
      padding: 4px 10px;
      width: 80px;
      border-radius: 20px;
      background: #f1f1f1;
      border: 1px solid #eee;
      color: #898989;
      margin-right: 10px;
      text-align: center;
      cursor: pointer;
      &.select {
        background: #67b0dc;
        color: #fff;
      }
    }
  }
}
</style>
